<template>
	<div class="categ_info" v-if="obj_to_null(this.cur_item)">
		<info_field f_uniq="ct"
					f_type="title"
					:is_disabled="false"
					@update_categ="change_atr"
					:f_title="__t('NAME')"
					:f_val="cur_item.title">

		</info_field>
		<info_field f_uniq="cid" :f_title="__t('UNIQ_GO_CODE')"  :f_val="cur_item.id.toString()"></info_field>
		<info_field f_type="uniq_id" @update_categ="change_atr" :is_disabled="false" f_uniq="cid2" :f_title="__t('UNIQ_CODE')"  :f_val="cur_item.uniq_id.toString()"></info_field>

		<div class="form-group">
			<label class="form-label" for="name-f">{{__t("DATE_CREATE")}}</label>
			<div class="input-group">
				<div class="input-group-prepend">
						<span class="input-group-text text-success">
							<i class="fal fa-calendar-edit fs-xl"></i>
						</span>
				</div>
				<input type="text" class="form-control" id="name-f" disabled v-model="cur_item.added">
				<input type="text" class="form-control" id="name-l" disabled v-model="cur_item.updateAt">
			</div>
		</div>
	</div>
</template>

<script>
import Info_field from "../../../sys/info_field";

export default {
	name: "organization_info",
	components: {Info_field},
	props : {
		org : {
			type : Object
		}
	},
	data() {
		return {
			cur_item : this.org,
			is_load: false,
		}
	},
	methods :  {
		change_atr(atr_name,atr_val) {
			if(this.cur_item.hasOwnProperty(atr_name)) {
				this.cur_item[atr_name] = atr_val;
			}
		}
	},
	computed : {
		is_disabled () {
			return this.cur_item.id > 0;
		},
	},
}
</script>

<style scoped>

</style>
